import { gql } from "@apollo/client";
import { EVENT_NODE_FIELDS, EVENT_PAGINATION_FIELDS, EVENT_RESULT_FILTER_METADATA } from "graphql/fragments";

const GET_PROFILE_EVENTS = gql`
  ${EVENT_NODE_FIELDS}
  ${EVENT_PAGINATION_FIELDS}
  ${EVENT_RESULT_FILTER_METADATA}
  query profileEvents(
    $profileId: ID!
    $sortKey: String
    $sortDirection: String
    $filters: TimelineEventFilter
    $advancedFilters: [AdvancedFilter!]
    $resultFilterMetadata: [String!]
    $paginationInfo: PaginationInfo
  ) {
    profileEvents(
      profileId: $profileId
      sortKey: $sortKey
      sortDirection: $sortDirection
      filters: $filters
      advancedFilters: $advancedFilters
      resultFilterMetadata: $resultFilterMetadata
      paginationInfo: $paginationInfo
    ) {
      ...EventPaginationFields
      filterMetadata {
        ...TimelineEventsResultFilterMetadata
      }
      nodes {
        ...EventNodeFields
      }
    }
  }
`;

export { GET_PROFILE_EVENTS };
